export default {
  dashboard: 'Главная',
  introduction: 'Introduction',
  documentation: 'Документация',
  guide: 'Руководство',
  roadmap: 'Дорожная карта',
  i18n: 'i18n',
  theme: 'Оформление',
  // pagePermission: 'Page Permission',
  // rolePermission: 'Role Permission',
  permissions: 'Разрешения',
  permission: {
    admin: 'Админ',
    editor: 'Редактор',
    visitor: 'Посетитель',
  },
  components: 'Компоненты',
  component: {
    avatarUpload: 'Avatar Upload',
    backToTop: 'Back To Top',
    countTo: 'Count To',
    dragKanban: 'Drag Kanban',
    dropzone: 'Dropzone',
    jsonEditor: 'Json Editor',
    markdown: 'Markdown',
    splitPane: 'Split Pane',
    sticky: 'Sticky',
    tinymce: 'Tinymce',
  },
  vuetify: 'Vuetify UI',
  vuetifyComponents: {
    components: 'Components',
    alert: 'Alert',
    avatar: 'Avatars',
    badge: 'Badges',
    buttons: 'Buttons',
    calendar: 'Calendar',
    cards: 'Cards',
    carousels: 'Carousels',
    chip: 'Chip',
    colors: 'Colors',
    datepicker: 'Datepicker',
    dialogs: 'Dialogs',
    grid: 'Grid',
    icon: 'Icons',
    pagination: 'Pagination',
    parallax: 'Parallax',
    progress: 'Progress',
    slider: 'Slider',
    snackbar: 'Snackbar',
    tables: 'Tables',
    timepicker: 'Timepicker',
    tooltip: 'Tooltip',
    typography: 'Typography',
  },
  errors: 'Ошибки',
  errorPages: {
    page301: '301',
    page401: '401',
    page403: '403',
    page404: '404',
    page500: '500',
  },
  charts: 'Графики',
  chart: {
    keyboardChart: 'Гистограмма',
    lineChart: 'Линейный',
    mixChart: 'Смешанный',
  },
  nested: {
    nested: 'Вложенные',
    nested1: 'Уровень 1',
    nested2: 'Уровень 2',
    nested3: 'Уровень 3',
  },
  clipboard: 'Буфер обмена',
  externalLink: 'Внешняя ссылка',
  config: 'Config',
};
